import { useCallback, type FC } from "react";
import RestrictedByTooltip from "components/restrictedByTooltip/RestrictedByTooltip";
import { BasicLinkButton } from "components/buttons/linkButtons";
import { type CampaignSendOverview } from "../../types/state";
import { CampaignRunStatuses } from "enums/CampaignRunStatuses";
import EllipsisPopupButton from "components/buttons/ellipsisPopupButton/EllipsisPopupButton";

export interface CampaignRunItemMenuProps {
  item: CampaignSendOverview;
  handleCompleteClick: (id: number) => void;
  handleCancelClick: (id: number) => void;
  readonly?: boolean;
  isChecked?: boolean;
  hasPermission?: boolean;
}

export const CampaignRunItemMenu: FC<CampaignRunItemMenuProps> = (props) => {
  const { readonly, isChecked, item, handleCompleteClick, handleCancelClick, hasPermission = true } = props;

  const onCompleteClick = useCallback(() => handleCompleteClick(item.id), [handleCompleteClick, item.id]);
  const onCancelClick = useCallback(() => handleCancelClick(item.id), [handleCancelClick, item.id]);

  return (
    <RestrictedByTooltip hasPermission={hasPermission}>
      <EllipsisPopupButton
        circle
        outlinedEllipsis
        disabled={
          readonly ||
          isChecked ||
          item.statusId === CampaignRunStatuses.Completed ||
          item.statusId === CampaignRunStatuses.Canceled
        }
      >
        <BasicLinkButton
          text="Complete"
          onClick={onCompleteClick}
          isDisabled={item.statusId !== CampaignRunStatuses.InProgress}
        />
        <BasicLinkButton text="Cancel" onClick={onCancelClick} />
      </EllipsisPopupButton>
    </RestrictedByTooltip>
  );
};
